import { Heading } from "@digipost/dds-heading-react";
import Translated from "../infrastructure/translation/Translated";
import { BedriftskundeInfo } from "./BedriftskundeInfo";

export function InfoPage() {
  return (
    <main>
      <Heading level={1} size={"large"}>
        <Translated textKey={"infopage.header"} />
      </Heading>
      <BedriftskundeInfo showLoginButton />
    </main>
  );
}
